import {UserRole} from "../../../../common/access/UserRole";
import {UserRoleType} from "../../../../common/access/UserRoleType";
import {UserDto} from "../../../../common/apis/user/UserDto";

export interface UserGroupsPageAccessResolver {
    hasPageAccess(user?: UserDto): boolean
}

class UserGroupsPageAccessResolverImpl implements UserGroupsPageAccessResolver {

    hasPageAccess(user?: UserDto): boolean {
        return user != null && UserRole.isAtLeast(user, UserRoleType.ROLE_SPRAVCE);
    }

}

const userGroupsPageAccessResolver = new UserGroupsPageAccessResolverImpl();
export default userGroupsPageAccessResolver;
